<template>
    <div class="modal-content">
        <div class="modal-header">
            <h5 class="modal-title" >Confirmar Dados</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
            </button>
        </div>

        <div class="modal-body p-0">

            <div class="card mx-0">
                <div class="card-header">
                    <h4 class="card-title">Pedido</h4>
                </div>
                <div class="card-body p-0">

                    <table class="table">
                        <thead>
                            <tr>
                                <th>Produto</th>
                                <th width="30px">Qt</th>
                                <th class="text-right" width="110px">Valor</th>
                            </tr>
                        </thead>

                        <tbody>

                            <tr v-for="item in dados_produtos">
                                <template v-if="item.tipo == 1">
                                    <td scope="row">
                                        <strong>{{item.produto.nome}}</strong>
                                        <template v-if="Array.isArray(item.opcionais)">
                                            <template v-for="opcional in item.opcionais" ><br>+{{ opcional.nome }} </template><br>
                                        </template>
                                        <template v-else>
                                            <template v-if="item.opcionais" ><br>+{{ item.opcionais.nome }} </template><br>
                                        </template>
                                        {{ item.obs }}
                                    </td>
                                    <td>{{ item.quantidade }}</td>
                                    <td class="text-right">R$ {{ formatarMoeda(item.valor_total) }}</td>
                                </template>

                                <template v-if="item.tipo == 2">
                                    <td scope="row">
                                        <strong>Pizza {{item.tamanho.nome}}</strong> <br>
                                        <template v-if="!(Object.keys(item.borda).length === 0 && item.borda.constructor === Object)" >Borda: {{ item.borda.nome }} <br></template>

                                        <template v-if="!(Object.keys(item.massa).length === 0 && item.massa.constructor === Object)" >Massa: {{ item.massa.nome }} <br></template>

                                        <template v-if="item.sabores.length > 0" >
                                            Sabor:
                                            <template v-for="sabor in item.sabores" >| {{ sabor.nome }} |</template><br>
                                        </template>
                                        {{ item.obs }}
                                    </td>
                                    <td>{{ item.quantidade }}</td>
                                    <td class="text-right">R$ {{ formatarMoeda(item.valor_total) }}</td>
                                </template>

                                <template v-if="item.tipo == 3">
                                    <td scope="row">
                                        <strong>Clone</strong> <br>
                                        {{ item.obs }}
                                    </td>
                                    <td>{{ item.quantidade }}</td>
                                    <td class="text-right">R$ {{ formatarMoeda(item.valor_total) }}</td>
                                </template>


                            </tr>







                        </tbody>
                    </table>




                </div>

            </div>

            <div class="card mx-0">
                <div class="card-header">
                    <h4 class="card-title">Entrega</h4>
                </div>
                <div class="card-body">

                    <template v-if="dados_entrega.entrega_id == 1">
                        <h5>Vou retirar no Balcão</h5>
                        <a href="#" v-on:click="dispararEvento('endereco')">alterar</a>
                    </template>

                    <template v-if="dados_entrega.entrega_id == 2">
                        <h5>Entregar no meu endereço</h5>
                        <p>{{ dados_entrega.endereco_formatado }}</p>
                        <a href="#" v-on:click="dispararEvento('endereco')">alterar</a>
                    </template>

                    <template v-if="dados_entrega.entrega_id == 3">
                        <h5>Vou comer no local</h5>
                        <a href="#" v-on:click="dispararEvento('endereco')">alterar</a>
                    </template>

                </div>

            </div>

            <div class="card mx-0">
                <div class="card-header">
                    <h4 class="card-title">Pagamento</h4>
                </div>
                <div class="card-body">

                    <template v-if="dados_pagamento.pagamento_id == 1">
                        <h5>Dinheiro</h5>
                        <p>Troco para: R$ {{ formatarMoeda(dados_pagamento.troco??0) }}</p>
                        <a href="#" v-on:click="dispararEvento('pagamento')">alterar</a>
                    </template>

                    <template v-if="dados_pagamento.pagamento_id == 2">
                        <h5>Cartão</h5>
                        <p>{{ dados_pagamento.bandeira_nome }}</p>
                        <a href="#" v-on:click="dispararEvento('pagamento')">alterar</a>
                    </template>

                    <template v-if="dados_pagamento.pagamento_id == 3">
                        <h5>Pix</h5>
                        <a href="#" v-on:click="dispararEvento('pagamento')">alterar</a>
                    </template>

                </div>

            </div>

            <div class="card mt-4">
                <div class="card-body px-0">

                    <table class="table">

                        <tr v-if="valorItens!=null">
                            <th>Valor dos itens:</th>
                            <td class="text-right">R$ {{ formatarMoeda(valorItens) }}</td>
                        </tr>

                        <tr v-if="dados_entrega.frete!=0">
                            <th>Frete</th>
                            <td class="text-right">R$ {{ formatarMoeda(dados_entrega.frete) }}</td>
                        </tr>

                        <tr v-if="dados_pagamento.desconto!=0">
                            <th>Desconto</th>
                            <td class="text-right">- R$ {{ formatarMoeda(dados_pagamento.desconto) }}</td>
                        </tr>

                        <tr>
                            <th><h3>Valor Total:</h3></th>
                            <td class="text-right"><h3>R$ {{ formatarMoeda(valorTotal) }}</h3></td>
                        </tr>
                    </table>

                </div>
            </div>






        </div>

        <div class="modal-footer">
            <button type="button" class="btn btn-secondary mr-auto" data-dismiss="modal">Fechar</button>

            <button type="submit" class="btn b-btn" v-on:click="dispararEvento('pagamento')" >voltar</button>
            <button type="submit" class="btn b-btn" :disabled="isSubmitting" v-on:click="debouncedSubmitOrder" >Finalizar Pedido</button>
        </div>

    </div>
</template>

<script>
    import debounce from 'lodash/debounce';
    import api from "../../service/api";
    export default {

        props: ['inquilino', 'usuario', 'valorItens', 'valorTotal', 'dados_entrega', 'dados_pagamento', 'dados_produtos'],

        data () {
            return {
                carregando:false,
                status:'',
                enviando_pedido:false,

                isSubmitting: false,

                form: new Form({
                    cupom_id: '',
                    codigo_desconto: '',
                    usuario_id: '',
                    endereco_id: '',
                    pagamento_id: '',
                    bandeira_id: '',
                    entrega_id: null,
                    troco: '',
                    frete: '',
                    obs: '',
                    itens: []

                }),


            }
        },

        watch: {

        },

        computed: {

        },

        methods: {

            dispararEvento(pagina){

                var obj = {
                    pagina: pagina,
                };

                this.$emit('componente-ativo', obj);

            },

            formatarMoeda(valor){
                return parseFloat(valor).toFixed(2).replace(".",",")
            },

            async verificarStatus(){
                await api
                .get('/status')
                .then(response => (this.status = response.data.status));
            },

            async enviarPedido(){
                if (this.isSubmitting) return;

                this.isSubmitting = true;

                await this.verificarStatus();

                if (this.status=="Aberto") {

                    this.carregando = true;
                    this.enviando_pedido = true;

                    this.montarDados();

                    await this.form
                    .post('/api/pedidos')
                    .then((response)=>{
                        if(response.data.success){

                            $('#modalFinalizarCompra').modal('hide');
                            this.$store.dispatch('limparProdutos').then();
                            this.form.reset();
                            this.form.errors.errors = {};

                            Toast.fire({
                                    icon: 'success',
                                    title: response.data.message
                            });

                            this.$router.push("/site/pedidos");

                        } else {

                            this.form.errors.errors =  response.data.error;

                            Toast.fire({
                                icon: 'error',
                                title: 'Erro na resposta'
                            });

                            // this.$Progress.failed();
                        }
                    })
                    .catch((e)=>{

                        if (e.errors) {

                            Swal.fire({
                                title: 'Estabelecimento Fechado!',
                                text: "Tente comprar durante o horário de expediente",
                                confirmButtonColor: '#3085d6',
                                confirmButtonText: 'Ok!'
                            }).then((result) => {

                                // Send request to the server
                                if (result.value) {
                                    $('#modalFinalizarCompra').modal('hide');
                                }
                            })
                        }

                        console.log(e)
                        Toast.fire({
                            icon: 'error',
                            title: 'Algo deu errado!'
                        });
                    })

                    this.carregando = false;
                    this.enviando_pedido = false;
                }else{

                    Swal.fire({
                        title: 'Estabelecimento Fechado!',
                        text: "Tente comprar durante o horário de expediente",
                        confirmButtonColor: '#3085d6',
                        confirmButtonText: 'Ok!'
                    }).then((result) => {

                        // Send request to the server
                        if (result.value) {
                            $('#modalFinalizarCompra').modal('hide');
                        }
                    })



                }

                this.isSubmitting = false;

            },

            montarDados(){

                this.form.usuario_id = this.usuario.id ;
                this.form.endereco_id = this.dados_entrega.endereco_id ;
                this.form.entrega_id = this.dados_entrega.entrega_id ;
                this.form.frete = this.dados_entrega.frete ;

                this.form.codigo_desconto = this.dados_pagamento.cupom_id ;
                this.form.pagamento_id = this.dados_pagamento.pagamento_id ;
                this.form.bandeira_id = this.dados_pagamento.bandeira_id ;
                this.form.troco = this.dados_pagamento.troco ;
                this.form.cupom_id = this.dados_pagamento.cupom_id ;
                this.form.obs = "" ;


                let itens = [];

                for (let index = 0; index < this.dados_produtos.length; index++) {

                    if (this.dados_produtos[index].tipo==1) {
                        let opcionais = [];
                        let mp_itens = [];
                        if (this.dados_produtos[index].produto.grupoopcional) {
                            if (this.dados_produtos[index].produto.grupoopcional.multipla_escolha==1) {
                                for (let index2 = 0; index2 < this.dados_produtos[index].opcionais.length; index2++) {
                                    opcionais.push( this.dados_produtos[index].opcionais[index2].id);
                                }
                            }else{
                                opcionais.push( this.dados_produtos[index].opcionais.id);
                            }
                        }

                        if (this.dados_produtos[index].produto.etapas) {
                            for (let index2 = 0; index2 < this.dados_produtos[index].etapas.length; index2++) {
                                mp_itens.push( this.dados_produtos[index].etapas[index2]);
                            }
                        }



                        itens.push({
                            'tipo': 1,
                            'quantidade':  this.dados_produtos[index].quantidade,
                            'produto_id': this.dados_produtos[index].produto.id,
                            'obs': this.dados_produtos[index].obs,
                            'opcionais_ids': opcionais,
                            'mp_itens': mp_itens
                        });
                    }else if (this.dados_produtos[index].tipo==2) {
                        let sabores = [];

                        for (let index2 = 0; index2 < this.dados_produtos[index].sabores.length; index2++) {
                            sabores.push( this.dados_produtos[index].sabores[index2].id);
                        }

                        itens.push({
                            'tipo': 2,
                            'quantidade':  this.dados_produtos[index].quantidade,
                            'tamanho_id': this.dados_produtos[index].tamanho.id,
                            'borda_id': this.dados_produtos[index].borda.id??0,
                            'massa_id': this.dados_produtos[index].massa.id??0,
                            'sabores_ids': sabores,
                            'obs': this.dados_produtos[index].obs,
                        });
                    }else if (this.dados_produtos[index].tipo==3) {
                        let produtos = [];

                        for (let index2 = 0; index2 < this.dados_produtos[index].produtos.length; index2++) {
                            let sabores = [];

                            for (let index3 = 0; index3 < this.dados_produtos[index].produtos[index2].sabores.length; index3++) {
                                sabores.push( this.dados_produtos[index].produtos[index2].sabores[index3].id);
                            }

                            produtos.push({
                                "tipo":2,
                                "tamanho_id": this.dados_produtos[index].tamanho_id,
                                "borda_id": this.dados_produtos[index].produtos[index2].borda.id??0,
                                "massa_id": this.dados_produtos[index].produtos[index2].massa.id??0,
                                "sabores_ids": sabores,
                                "obs": this.dados_produtos[index].produtos[index2].obs
                            });
                        }

                        itens.push({
                            'tipo': 3,
                            'quantidade':  this.dados_produtos[index].quantidade,
                            'nome': this.dados_produtos[index].nome,
                            'clone_id': this.dados_produtos[index].clone_id,
                            'valor': this.dados_produtos[index].valor,
                            'produtos': produtos,
                            'obs': this.dados_produtos[index].obs,
                        });
                    }

                }

                this.form.itens = itens ;

            },


        },

        created() {
            this.debouncedSubmitOrder = debounce(this.enviarPedido, 500);
        },

        mounted() {

            this.montarDados();
        }

    }
</script>

<style lang="scss" scoped>

</style>
